import MetaTags from "./index";
import config from "@/lib/config";
import routes from "@/lib/routes";

export function tags() {
  return {
    title: "SPOOX(スプークス)の単品動画 |  スカパー！の動画配信サービス",
    keywords: "SPOOX,スプークス,動画配信,レンタル,スカパー！",
    description:
      "SPOOX(スプークス)なら、スポーツや映画やアニメなどをレンタルで楽しむことができます。",
    og: { type: "article", url: `${config.host.vod}${routes.store}` },
  };
}

export default function StorePageMetaTags() {
  const props = tags();

  return <MetaTags {...props} />;
}
